module.exports = __webpack_public_path__ + "img/zixun_1.4cf80519.png";